import * as _ from "lodash-es";
import React, { Component } from "react";
import PropTypes from "prop-types";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetVendorsDTO from "../../../models/DTO/IGetVendorsDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import IOnUpdateForecastGroupDTO from "../../../models/DTO/IOnUpdateForecastGroupDTO";
import IUpdateForecastGroupDTO from "../../../models/DTO/IUpdateForecastGroupDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import IForecast_Group from "../../../models/IForecast_Group";
import IntervalTypeEnum from "../../../models/IntervalTypeEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import PeriodTypesEnum from "../../../models/PeriodTypesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import moment from "moment";
import { Socket } from "socket.io-client";

type Props = {
    history: any;
    cancelFn: () => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    forecastGroup?: IForecast_Group;
};

type State = {
    catalogs: ICatalog[];
    catalogGuid?: string;
    vendorGuid?: string;
    formValid: boolean;
    clearVendorTypeahead: boolean;
    selectedVendor?: null | IVendorModel;
    foundVendors?: IVendorModel[];
    periodYear: string;
    periodStart: string;
};

class ForecastSidebar extends Component<Props, State> {
    readonly state: State = {
        catalogs: [],
        vendorGuid: this.props.userModel.isSupplierUser ? undefined : this.props.vendorModel.guid,
        formValid: false,
        clearVendorTypeahead: false,
        periodYear: "",
        periodStart: "",
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ForecastOnUpdateForecastGroup, this.onUpdateForecastGroup);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ForecastOnUpdateForecastGroup, this.onUpdateForecastGroup);
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
    }

    findVendorsByName = async (typeahead: string) => {
        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload: IGetVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = _.map(data.supplierVendorTokens, (tokenData) => {
            return tokenData.Vendor;
        });

        const state: any = {
            foundVendors,
        };

        this.setState(state);
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "ForecastSidebar",
                fn: "getCatalogs",
            },
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    createForecastGroup = () => {
        if (this.state.catalogGuid && this.state.vendorGuid) {
            let periodStart = this.state.periodStart;
            const periodYear = this.state.periodYear;

            console.log("periodYear", periodYear);

            if (periodStart === "H1") {
                periodStart = moment(periodYear).format("YYYY-01-01");
            } else {
                periodStart = moment(periodYear).format("YYYY-07-01");
            }

            const catalogGuid = this.state.catalogGuid;

            const payload: IUpdateForecastGroupDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.vendorGuid,
                periodStart,
                periodYear,
                intervalTypeId: IntervalTypeEnum.SEMIANNUALLY,
                catalogGuid,
            };

            this.props.socket.emit(EndpointsEnum.ForecastUpdateForecastGroup, payload);
        }
    };

    onUpdateForecastGroup = (data: IOnUpdateForecastGroupDTO) => {
        // navigate to the forecast group detail view
        this.props.cancelFn();
        // this.props.history(`forecast/${data.guid}`);
    };

    cancel = () => {
        this.props.cancelFn();
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    clearTypeaheadCallback = () => {
        this.setState({
            selectedVendor: null,
            formValid: false,
        });
    };

    selectedVendor = (vendor: IVendorModel) => {
        // do something with the selected vendor?
        console.log("selectedVendor: ", vendor);

        // const formValid = this.performFormValidation(vendor);

        const state: any = {
            foundVendors: null,
            selectedVendor: vendor,
            vendorGuid: vendor.guid,
            // formValid,
        };

        this.setState(state);
    };

    render() {
        const yearOptions = [
            { value: moment().format("YYYY-01-01"), title: moment().format("YYYY") },
            {
                value: moment().add(1, "year").format("YYYY-01-01"),
                title: moment().add(1, "year").format("YYYY"),
            },
            {
                value: moment().add(2, "year").format("YYYY-01-01"),
                title: moment().add(2, "year").format("YYYY"),
            },
        ];

        const periodOptions = [
            { value: "H1", title: "H1" },
            { value: "H2", title: "H2" },
        ];

        return (
            <div className="ForecastSidebar p-2">
                <div className={"d-flex align-items-end"}>
                    <div className={"ms-auto d-inline-flex"}>
                        <OwButton centerIconClass={"far fa-times"} fn={this.cancel} className={"btn btn-danger btn-sm"} />
                    </div>
                </div>
                <div>
                    <OwTitle title={"create_forecast"} leftIconName={"fad fa-chart-line"} />
                </div>
                <hr />
                <div className={"d-flex flex-column"}>
                    <div>
                        <div>
                            <OwLabel title={"catalog"} noBottomMargin={true} isBold={true} />
                        </div>
                        <OwSelectOption
                            valueProp={"guid"}
                            titleProp={"name"}
                            options={this.state.catalogs}
                            name={"catalogGuid"}
                            fn={this.handleChange}
                            showBlankFirst={true}
                        />
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel
                                isBold={true}
                                noBottomMargin={true}
                                title={"vendor"}
                                supplierModel={this.props.supplierModel}
                                isSupplierVendorOverride={true}
                            />
                        </div>
                        {this.props.userModel.isSupplierUser ? (
                            <div className="position-relative">
                                <Typeahead
                                    className=""
                                    clearTypeahead={this.state.clearVendorTypeahead}
                                    clearTypeaheadCallback={() => {
                                        this.clearTypeaheadCallback();
                                    }}
                                    typeaheadItems={this.state.foundVendors}
                                    titleProp="name"
                                    subTitleProp=""
                                    maxResults={5}
                                    isRequired={true}
                                    placeholder="Search"
                                    selectedItem={this.state.selectedVendor}
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    selectedItemFn={this.selectedVendor}
                                    typeaheadApiFn={this.findVendorsByName}
                                />
                            </div>
                        ) : (
                            this.props.vendorModel.name
                        )}
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel isBold={true} title={"year"} noBottomMargin={true} />
                        </div>
                        <OwSelectOption
                            valueProp={"value"}
                            titleProp={"title"}
                            options={yearOptions}
                            name={"periodYear"}
                            selectedOption={this.state.periodYear}
                            selectedOptionProp={"value"}
                            fn={this.handleChange}
                            showBlankFirst={true}
                        />
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel isBold={true} title={"period"} noBottomMargin={true} />
                        </div>
                        <OwSelectOption
                            valueProp={"value"}
                            titleProp={"value"}
                            options={periodOptions}
                            name={"periodStart"}
                            fn={this.handleChange}
                            showBlankFirst={true}
                        />
                    </div>

                    <div className={"mt-2"}>
                        <OwButton title={"create"} fn={this.createForecastGroup} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ForecastSidebar;
